<script>
    import { tooltip } from "@svelte-plugins/tooltips";
    
    import AimTooltip from '../../../component/AimTooltip.svelte'

    import { getTooltipDisplayOptions } from '../../../stores.js';
    import { formatDate, getIsoDateStringAsDate, getDaysDifference } from '../../../date-time.js';
    import { getContactWarning, getContactWarningTooltip } from '../../../contact.js';
    import { Tooltip } from "sveltestrap";

    export let id;
    export let note;
    export let date;
    export let displayDateOnly = false;
    export let upcoming = false;

    export let overdueDays = null; 
    export let targetedTotalIncreased = null;
    export let isolationIncreased = null;

    $: displayedNotes = (note && note.length > 100) ? (note.substring(0, 100) + '...') : note;
    $: contactWarning = targetedTotalIncreased != null && isolationIncreased != null && getContactWarning(0, targetedTotalIncreased, isolationIncreased, null);
    $: difference = date ? getDaysDifference(getIsoDateStringAsDate(date), new Date()) : null;
</script>

<style>
    .contact-note {
        font-size: 12px;
        color: #6c757d;
        background-color: #ffffe5;
        width: 100%;
        margin-bottom: 10px;
        box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, .1);
    }

    .contact-note.contact-note-upcoming {
        background-color: white;
    }

    .contact-note-head {
        border-bottom: 1px solid rgba(0, 0, 0, .125);
        padding: 1px 0;
    }

    .contact-note-upcoming .contact-note-head {
        background-color: white;
    }

    .contact-note-head > span.contact-date {
        display: inline-block;
        width: 100%;
        text-align: center;
    }

    .contact-note-head > span.contact-warning i {
        position: absolute;
        left: 4px;
    }

    .contact-note-head .overdue {
        color: #721c24;
    }

    .contact-warning-icon {
        color: #bb2e3b;
    }

    .contact-note-body {
        text-align: center;
        padding: 5px 10px;
        max-height: 90px;
        overflow: hidden;
    }

    .contact-note-date-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-bottom: 5px;
    }

    .contact-note-date {
        display: flex;
        flex: 0 0 36px;
        height: 36px;
        flex-direction: column;
        align-items: center;
        position: relative;
        background-color: #ffffe5;
        border: 1px solid #ced4da;
        margin-right: 5px;
    }

    .contact-note-upcoming .contact-note-date {
        background-color: white;
    }

    .contact-note-date-item:first-of-type {
        font-size: 15px;
        line-height: 17px;
        padding-top: 2px;
    }

    .contact-note-date-item:last-of-type {
        padding-bottom: 2px;
        font-size: 11px;
        line-height: 13px;  
    }

    .contact-note-date-item {
        color: #6c757d;
    }
</style>

<button class="focus-outline button-reset" on:click>
    {#if !displayDateOnly}
        <div class="contact-note" class:contact-note-upcoming={upcoming}>
            <div class="contact-note-head">
                {#if contactWarning}
                    <span class="contact-warning contact-warning-icon" use:tooltip={{
                        content: {
                            component: AimTooltip,
                            props: getContactWarningTooltip(1, null, 0, targetedTotalIncreased, isolationIncreased)
                        },
                        ...getTooltipDisplayOptions({ position: 'right'})
                    }}>
                        <i class="bi bi-exclamation-circle-fill" />
                    </span>
                {/if}

                <span class="contact-date" id={`${id}-date`} class:overdue={upcoming && overdueDays > 0}>
                    {#if upcoming}
                        <span class:contact-warning-icon={overdueDays > 0}>
                            <i class="bi bi-clock{(overdueDays > 0) ? '-fill' : ''}" />
                        </span>
                    {/if}
                    {formatDate(date)}
                </span>
                {#if upcoming && overdueDays > 0}
                    <Tooltip target={`${id}-date`} placement="bottom">
                        Overdue by {overdueDays} day{(overdueDays > 1) ? 's' : ''}
                    </Tooltip>
                {/if}
            </div>

            <div class="contact-note-body" id={`${id}-details`}>
                {#if upcoming && note == null}
                    <span>
                        {#if overdueDays > 0}
                            Follow-up was due 
                            {#if overdueDays == 1}
                                yesterday
                            {:else}
                                {overdueDays} days ago
                            {/if}
                        {:else}
                            Follow-up is due 
                            {#if difference == 0}
                                today
                            {:else if difference == 1}
                                tomorrow
                            {:else}
                                in {difference} days
                            {/if}
                        {/if}
                    </span>
                {:else}
                    <span>{displayedNotes}</span>
                {/if}
            </div>
        </div>
    {:else}
        <div class="contact-note-date-row" class:contact-note-upcoming={upcoming}>
            <div class="contact-note-date" id={`${id}-details`}>
                <span class="contact-note-date-item">
                    {getIsoDateStringAsDate(date).toLocaleString('default', { day : 'numeric' })}
                </span>
                <span class="contact-note-date-item">
                    {getIsoDateStringAsDate(date).toLocaleString('default', { month : 'short' })}
                </span>
            </div>
        </div>
    {/if}
</button>